import logo from '@~assets/logo/logo.png';

export const StaticLogo = () => {
  return <img src={logo} width={150} alt="Aurous Finance" />;
};
